import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=b6cb6882&scoped=true&"
import script from "./slides.vue?vue&type=script&lang=js&"
export * from "./slides.vue?vue&type=script&lang=js&"
import style0 from "./slides.vue?vue&type=style&index=0&id=b6cb6882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb6882",
  null
  
)

export default component.exports